export default __webpack_public_path__ + "static/media/primebox.94e362bc.png";